<template>
	<div class="menu-wrapper" v-if="!item.meta.hidden">
		<template v-if="hasOneShowingChild(item.children, item)  && (!onlyOneChild.children || onlyOneChild.noShowingChildren) && !item.meta.alwaysShow">
			<app-link v-if="onlyOneChild.meta && onlyOneChild.meta.requiresAuth" :to="resolvePath(onlyOneChild.path)">
				<el-menu-item :index="resolvePath(onlyOneChild.path)">
					<div class="el-menu-item-div-box">
						<i v-if="onlyOneChild.meta.icon" :class="onlyOneChild.meta.icon" class="sita-nav-icon"></i>
						<span>
							{{onlyOneChild.meta.title}}
						</span>
					</div>
				</el-menu-item>
			</app-link>
			<app-link v-if="onlyOneChild.meta && !onlyOneChild.meta.requiresAuth" :to="resolvePath(onlyOneChild.path) + `?uid=${userInfo.yunUid}&company=${userInfo.enterpriseName}&mobile=${userInfo.moblie}&source=zs`" data-url="link">
				<el-menu-item :index="resolvePath(onlyOneChild.path)">
					<div class="el-menu-item-div-box">
						<i v-if="onlyOneChild.meta.icon" :class="onlyOneChild.meta.icon" class="sita-nav-icon"></i>
						<span>
							{{onlyOneChild.meta.title}}
						</span>
					</div>
				</el-menu-item>
			</app-link>
		</template>
			<el-submenu v-else ref="subMenu" :index="resolvePath(item.path)" popper-append-to-body>
				<template slot="title">
					<div class="el-menu-item-div-box">
						<template  v-if="item.meta">
							<i :class="item.meta.icon"  class="sita-nav-icon"></i>
							<span>
								{{item.meta.title}}
							</span>
						</template>
					</div>
				</template>
				<side-menu-item
					v-for="child in item.children"
					:key="child.path"
					:is-nest="true"
					:item="child"
					:base-path="resolvePath(child.path)"
					class="nest-menu"
				/>
			</el-submenu>
	</div>
</template>

<script>
import {mapGetters} from 'vuex'
import path from 'path'
import AppLink from './Link'

export default {
	name: 'SideMenuItem',
	components: {
		'app-link': AppLink
	},
	data() {
		this.onlyOneChild = null
		return{

		}
	},
	computed: {
		...mapGetters('user', ['userInfo']),
		only() {
			return this.onlyOneChild
		}
	},
	props: {
		item: {
			type: Object,
			required: true
		},
		basePath: {
			type: String,
			default: ''
		}
	},
	methods: {
		hasOneShowingChild(children = [], parent) {
			const showingChildren = children.filter( item => {
				if(item.meta.hidden) {
					return false
				} else {
					this.onlyOneChild = item
					return true
				}
			})
			if(showingChildren.length === 1) {
				return true
			}
			if(showingChildren.length === 0) {
				this.onlyOneChild = { ...parent, path: '', noShowingChildren: true}
				return true
			}
			return false
		},
		isExternal(path) {
			return /^(https?:|mailto:|tel:)/.test(path)
		},
		resolvePath(routePath) {
			if(this.isExternal(routePath)) {
				return routePath
			}
			if (this.isExternal(this.basePath)) {
				return this.basePath
			}
			return path.resolve(this.basePath, routePath)
		}
	}
}

</script>

<style lang="scss" scoped>
.sita-nav-icon{
	margin-top: 2px;
	margin-right: 8px;
	font-size: 19px;
	color: $colorG;
	width: 20px;
	height: 20px;
	display: inline-block;
}

// .side-nav {
// 	li {
// 		a {
// 			display: block;
// 			line-height: 60px;
// 			border-bottom: 1px solid #eff0f2;
// 			cursor: pointer;
// 			border-left: 2px solid transparent;

// 			i {
// 				margin: 0 15px 0 34px;
// 			}

// 			&.router-link-active,
// 			&:hover {
// 				background: #fff;
// 				border-left: 2px solid #0686d8;
// 				color: #0686d8;

// 				.i-wdzd {
// 					background-position: -96px -21px;
// 				}

// 				.i-lltj {
// 					background-position: 0px -74px;
// 				}

// 				.i-kfxp {
// 					background-position: -24px -74px;
// 				}

// 				.i-order {
// 					background-position: -74px -26px;
// 				}

// 				.i-xtsz {
// 					background-position: -96px -63px;
// 				}
// 			}
// 		}

// 		.side-nav-child {
// 			max-height: 0;
// 			opacity: 0;
// 			overflow: hidden;
// 			transition: .2s;

// 			&.side-nav-child2 {
// 				max-height: 500px;
// 				opacity: 1;
// 				transition: .5s;
// 			}

// 			dd {
// 				a {
// 					line-height: 60px;
// 					border-bottom: 1px solid #eff0f2;
// 					text-indent: 71px;
// 					background: #fafcfe;
// 					cursor: pointer;

// 					&:hover {
// 						color: #0686d8;
// 					}
// 				}
// 			}
// 		}
// 	}
// }

</style>
